<div class="content-container mb-3">
  <div class="title controls d-inline-flex w-100 justify-content-between">
    <div>
      @if (titleJsonKey) {
        <span>
          <mwp-text-translate [text]="title" [jsonKey]="titleJsonKey" />
        </span>
      }
    </div>
    @if (currentBenefitName || displayStepper) {
      <div class="control-area d-inline-flex justify-content-end">
        @if (currentBenefitName) {
          <div class="message-card py-1 px-3 d-flex align-items-center">
            <span>{{ currentBenefitName }}</span>
          </div>
        }
        @if (displayStepper && steppers) {
          <div class="ms-3">
            <mat-form-field appearance="outline">
              <mat-select [(value)]="currentPanel" [disabled]="disableStepper" >
                @for (step of steppers; track step) {
                  <mat-option [value]="step.value" (onSelectionChange)="onStepChange($event)">
                    {{step.text}}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        }
      </div>
    }
  </div>
  @if (titleJsonKey && headerHTML) {
    <div class="content">
      <mwp-text-translate [text]="headerHTML" [jsonKey]="headerHTMLJsonKey" [isHTML]=true />
    </div>
  }
</div>